import React, { memo } from 'react';
import * as ShipConstants from '../../../../Global/Constants';
import { isSet } from '../../../../Utils/CommonFunctions';

const ImageData = (props)=>{
    const {colData,id,header} = props;
    const imgArr =  (Array.isArray(colData.value)===false || colData.value.length===0)?[""]:colData.value;
   
    // let imageDim = '2.4rem';
    // if(header.imgWidth!==undefined && header.imgWidth!==''){
    //     imageDim = header.imgWidth;
    // }
    return(
        <td key={id}>
        <div className="item-list" >
            <div className="avatar-xs">
                {imgArr.map((img,index)=>{
                    if(index===0){
                        let imgUrl = (isSet(img,null)!==null)?ShipConstants.API_URL+'files/download?fileId='+img:"/assets/img/profileImg.png";
                        return(
                            <img 
                                key={index}
                                src={imgUrl}
                                onError={({ currentTarget }) => {
                                    currentTarget.onerror = null; // prevents looping
                                    currentTarget.src="/assets/img/profileImg.png";
                                  }}
                                alt="..."  className="avatar-img rounded-circle" />
                        )
                    }
                })}
                
            </div>		 
        </div>
        </td>
    )
}


const isDiffProps = (prevProps,nextProps)=>{
    if(JSON.stringify(prevProps.colData.value)===JSON.stringify(nextProps.colData.value)){
      return true;
    }
} 
  
export default memo(ImageData,isDiffProps);
